import React, { useEffect, useState } from "react";
import Lenis from "lenis";
import { LanguageProvider } from "@/context/LanguageContext";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import About from "@/components/site/About";
import Story from "@/components/site/Story";
import OpenQuestions from "@/components/site/OpenQuestions";
import Steps from "@/components/site/Steps";
import Pricing from "@/components/site/Pricing";
import Guide from "@/components/site/Guide";
import BookingForm from "@/components/site/BookingForm";
import Closing, { Footer } from "@/components/site/Closing";
import CelestialBackground from "@/components/site/CelestialBackground";
import { scrollToId } from "@/lib/scroll";

const Landing = () => {
  const [pkg, setPkg] = useState("personal");

  useEffect(() => {
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (prefersReduced) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  const scrollToBooking = () => scrollToId("booking");
  const scrollToReadings = () => scrollToId("readings");
  const choosePackage = (id) => {
    setPkg(id);
    scrollToBooking();
  };

  return (
    <div className="mystic-bg grain min-h-screen relative overflow-x-hidden">
      <CelestialBackground />
      <Header onBook={scrollToBooking} />
      <main className="relative z-10">
        <Hero onBook={scrollToBooking} onReadings={scrollToReadings} />
        <Marquee />
        <About />
        <Story />
        <OpenQuestions />
        <Steps />
        <Pricing onChoose={choosePackage} />
        <Guide />
        <BookingForm selectedPackage={pkg} />
        <Closing onBook={scrollToBooking} />
      </main>
      <Footer />
      <Toaster position="top-center" theme="dark" />
    </div>
  );
};

const LandingPage = () => (
  <LanguageProvider>
    <Landing />
  </LanguageProvider>
);

export default LandingPage;
